var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4845 13.0553L40.2382 12.3224L39.4989 3.22725L31.6583 6.968L26.2584 0L21.229 7.11425L13.1658 2.86L12.7221 12.1745L3.55062 12.6149L7.0265 21.4159L0 25.7433L7.17437 31.1707L3.55062 38.8716L12.5011 39.8986L13.0195 48.6996L21.3785 44.7395L26.8499 52L31.7314 44.6664L39.4241 48.4071L40.0904 39.312L49.0409 39.0926L45.7129 31.538L52 26.1105L45.1214 20.5367L49.4845 13.0553ZM23.5414 34.2745L16.237 27.7859L17.8555 25.9642L23.218 30.7271L34.164 16.7115L36.0847 18.2114L23.5414 34.2745Z",
    fill: "#ED1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCheckmark);
export default __webpack_public_path__ + "static/media/RedCheckmark.b6beeb7a6da30a9aca6fb4f7b4d0fc01.svg";
export { ForwardRef as ReactComponent };